import Box from "@mui/material/Box";
import ChatbotAgentUI from "./components/ChatbotAgentUI";
import ApiKeyGate from "./apiKeyBus";

const Chat = () => {
  return (
    <ApiKeyGate>
      <Box>
        <ChatbotAgentUI />
      </Box>
    </ApiKeyGate>
  );
};

export default Chat;